import { render, staticRenderFns } from "./RevisionFinalForm.vue?vue&type=template&id=a8381a40&scoped=true"
import script from "./RevisionFinalForm.vue?vue&type=script&lang=js"
export * from "./RevisionFinalForm.vue?vue&type=script&lang=js"
import style0 from "./RevisionFinalForm.vue?vue&type=style&index=0&id=a8381a40&prod&lang=scss&scoped=true"
import style1 from "./RevisionFinalForm.vue?vue&type=style&index=1&id=a8381a40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8381a40",
  null
  
)

export default component.exports